import { useForm } from "react-hook-form";
import styled from "styled-components";
import axios from "axios";

import { useNavigate } from "@reach/router";
import Line1 from "../assets/images/line1.svg";
import { t } from "../lang";
const Activations = (props: any) => {
  const navigate = useNavigate();

  const { register, handleSubmit, watch, errors } = useForm();
  const onSubmit = async (data: any) => {
    console.log(data);

    const { pin } = data
    const mobile = localStorage.getItem('mobile')

    var config:any = {
      method: 'post',
      url: 'https://san-api.tatweertransit.com/san/verify',
      headers: {
        'Content-Type': 'application/json'
      },
      data : {pin,mobile}
    };
    
    let res = await axios(config);

    console.log(res);
    if(res.status ===200 && res.data.message === "OTP is valid"){
      localStorage.setItem('pin', pin);
      navigate("/industry_city", { replace: true });

    } else{
      alert('Not valid')
    }
    
    
    // navigate("/industry_city", { replace: true });
  };

  return (
    <Container className="Container">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Content className="Content">
          <Label>{t('Activation code')}</Label>
          <TextInput maxLength={4} name="pin" ref={register({ required: true, minLength: 4 })} />
          {errors && <span>{t('This field is required')}</span>}

          <Button type="submit">{t('submit')}</Button>
        </Content>
      </form>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100ch;
  width: 100vw;
  background-repeat-y: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url(${Line1});
`;

const Label = styled.h1`
font-size: 2.5em;
color:#182a33;
  margin-bottom: 1em;
  position: relative;
::before {
  border-top: 23px solid rgb(251 224 104);
  content: "";
  position: absolute;
  inset: 37px 0px 0px;
  width: 81%;
  z-index: -1;
}
`;
const TextInput = styled.input`
  display: block;
  box-sizing: border-box;
  min-width: 200px;
  border-radius: 4px;
  padding: 6px 10px;
  text-align: center;
  margin-bottom: 10px;
  font-size: 2em;
  border: 1px solid #fff;
`;

const Button = styled.button`
  border-radius: 4px;
  transition: all 0.3s;
  cursor: pointer;
  color: #fff;
  font-size: 1.5em;
  font-weight: 400;
  margin: 20px 0;
  -webkit-appearance: none;
  line-height: 1;
  display: inline-block;
  padding: 16px 10px;
  background: #182933;
  text-transform: uppercase;
  border: 1px solid #182933;
  min-width: 200px;
`;
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  flex-direction: column;
`;

export default Activations;
